import { SQLService } from '../../services/sql.service';
import { Flip } from '../../app.animations';
import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { ModalController, NavParams } from '@ionic/angular';
@Component({
  selector: 'app-select-payee',
  templateUrl: './select-payee.page.html',
  styleUrls: ['./select-payee.page.styl'],
  animations: [ Flip ]
})
export class SelectPayeePage implements OnInit {
  constructor(
    private router: Router,
    public sql: SQLService,
    private route: ActivatedRoute,
    private params: NavParams,
    private navCtrl: ModalController,
    private location: Location
  ) {
    var s = params.get('selected');
    if(s)this.selected = s.split(',');
    this.multiple = params.get('select_multiple');
    this.router.events.subscribe((eve) => {
      if(eve instanceof NavigationEnd) this.get_payees();
    });
  }
  count = -1;
  payees = [];
  output = new EventEmitter();
  selected =[];
  multiple: boolean;
  ngOnInit() {
    this.get_payees();
  }
  get_payees(event?) {
    this.sql.fetch('Payees',(e)=>{
      this.payees=e;
      this.count=e.length;
      setTimeout(()=>{if (event) event.target.complete();},1234);
    });
  }
  select_none() {this.navCtrl.dismiss(-1);}
  select(e) {
    if(this.multiple){
      this.toggle_item(e);
    } else {
      this.navCtrl.dismiss(e.payee_id);
    }
  }
  done_multiple() {
    this.navCtrl.dismiss(this.selected.join(','));
  }
  toggle_item(item) {
    if( this.selected.includes(item.payee_id) ) {
      this.deselect_item(item);
    } else {
      this.select_item(item);
    }
  }
  select_item(item) {
    console.log(item.payee_id);
    this.selected.push(item.payee_id);
  }
  deselect_item(item) {
    var new_selection=[];
    for(var i = 0; i < this.selected.length; ++i){
      if(this.selected[i]!=item.payee_id){
        new_selection.push(this.selected[i]);
      }
    }
    this.selected = new_selection;
  }
  select_all() {
    var new_selection=[];
    for (var i = 0; i < this.payees.length; ++i) {
      new_selection.push(this.payees[i].payee_id);
    }
    this.selected=new_selection;
  }
  deselect_all() {
   this.selected = []; 
  }
  add() {
    this.sql.count('Payees',(c)=>{
      if(this.sql.Trial && this.sql.Trial_Payees!=-1 && c>=this.sql.Trial_Payees) {
        this.sql.show_purhchase_modal();
      } else {
        this.router.navigate(['folder','Payee', 'New']);
      }
    });
    this.navCtrl.dismiss();
  }
  off() {
    // this.location.back();
    if(this.multiple){
      this.done_multiple();
     } else {
      this.navCtrl.dismiss();
     }
  }
}